import { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Spin } from 'antd';

import { IPage } from '../../../../../../interfaces/Extraction';
import PageChanger from '../PageChanger/PageChanger';

import './DocumentRender.less';

interface IDocumentRenderProps {
  pdfBase64: string;
  // TODO: esto queda para intentar unificar el visualizador con el del review receipt
  pages?: IPage[];
  loading: boolean;
}

const MAX_WIDTH_MODAL = 1200;

const DocumentRender = (props: IDocumentRenderProps) => {
  const { pdfBase64, loading } = props;
  const [modalWidth, setModalWidth] = useState<number>();
  const [numPages, setNumPages] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const modalContent = document.querySelector(
      '.ant-modal-content',
    ) as HTMLElement;
    if (modalContent) {
      const width = modalContent.offsetWidth;
      setModalWidth(width);
    }
  }, [window.innerWidth]);

  const onRenderSuccess = (page: any) => {
    const canvas = page.node;
    if (canvas) {
      const maxWidth = MAX_WIDTH_MODAL * 0.8;
      canvas.style.width = '100%';
      if (canvas.clientWidth > maxWidth) {
        canvas.style.width = `${maxWidth}px`;
      }
      canvas.width = canvas.clientWidth;
    }
  };
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <>
      <PageChanger
        pages={numPages}
        actualPageNro={pageNumber}
        setActualPageNro={setPageNumber}
      />
      {loading ? (
        <div className="spin-container">
          <Spin className="spin" size="large" />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Document file={pdfBase64} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
              pageNumber={pageNumber}
              width={modalWidth}
              onRenderSuccess={onRenderSuccess}
            />
          </Document>
        </div>
      )}
    </>
  );
};
export default DocumentRender;
